// CRM 2.0 stepper (M3-F2, M3.16 / M3.25, DC-74 / DC-95): Shortlisted · Application for Booking ·
// Allotment Letter · Final Draft · Registration · Agreement Complete. Each stage shows Done /
// In progress / Next under its name; no NEW STEP tags. Earlier stages can be opened to look back.
// Phone: a 3-stage window around the stage being viewed (as today's Home stepper).
import React from "react";
import { useMediaQuery } from "@mui/material";
import css from "./Crm2Booking.module.css";

export default function Crm2Stepper({ stages, cur, view, onView, allDone }) {
	const phone = useMediaQuery("(max-width:820px)");
	const lo = phone ? Math.max(0, Math.min(view - 1, stages.length - 3)) : 0;
	const hi = phone ? lo + 3 : stages.length;
	return (
		<div className={css.stp}>
			{stages.map((t, i) => {
				if (i < lo || i >= hi) return null;
				const st = i < cur ? css.done : i === cur ? css.cur : "";
				const label = i < cur || (i === cur && allDone) ? "Done" : i === cur ? "In progress" : i === cur + 1 ? "Next" : "";
				return (
					<div key={t} className={`${css.st} ${st} ${view === i && view !== cur ? css.view : ""}`} onClick={() => i <= cur && onView(i)}>
						<div className={css.ic}>
							{i < cur ? <span>✓</span> : i === cur ? <span><span className={css.d8} /></span> : <span className={css.d8} />}
						</div>
						<div className={css.lb}>
							{t}
							{label && <span className={`${css.sts} ${label === "Done" ? css.stsD : label === "Next" ? css.stsX : css.stsC}`}>{label}</span>}
						</div>
					</div>
				);
			})}
		</div>
	);
}
